<template>
  <div>

    <div>
      <div class="bannerWrap">
        <my-header> </my-header>
      </div>

      <div class="mainWrap" v-if='cpxxshow'>
        <div class="main">
          <!-- <div class="breadCrumbs">
            <h3>{{productname}}</h3>
            <span>
              <a>首页</a> &gt;
              <router-link to="/MixedCellSeries">
                <a>产品</a> &gt;
              </router-link>
              <em>{{productname}}</em>
            </span>
          </div> -->
          <!--内容开始-->
          <div class="content">
            <div class="product_xx">
              <div class="product_xx_top">

                <div class="crColorWrap">
                  <div class="xx_top_R">
                    <div class="bigimg">
                      <img :src="httpurl+productmessageList.image"
                           width="280"
                           height="280"
                           alt="">
                    </div>
                    <div class="smallimg">
                      <ul></ul>
                    </div>
                  </div>
                </div>

                <div class="xx_top_L">
                  <p class="crXinghao">{{productmessageList.titel}}</p>
                  <h3 @click="urllll()">{{productmessageList.name}}</h3>
                  <p class="p01">{{productmessageList.detail}}</p>
                  <div class="pc">
                    <p class="p02" price="6180.00" id="pPrice" v-if="this.$route.query.productmoreid != 1">   
                        <span class="zks"
                            v-if="this.$route.query.productmoreid == 2">折扣价:</span>
                        <span class="zks"
                            v-if="this.$route.query.productmoreid == 3">促销价:</span>
                        <span class="zks"
                            v-if="this.$route.query.more=='a'&&this.ukey!==0">会员价:</span>
                        <span v-if="this.$route.query.more!='a'">￥{{Allsum|toFixed(2)}}</span>
                        <span v-if="this.$route.query.more=='a'&&this.ukey!==0">￥{{Allsum*zk|toFixed(2)}}</span>
                        <s class="zks" v-if="this.$route.query.more=='a'&&this.ukey!==0">￥{{Allsum|toFixed(2)}}</s>

                        <s class="zks"
                        v-if="this.$route.query.productmoreid == 1||this.$route.query.productmoreid == 2||this.$route.query.productmoreid == 3"> ￥{{productmessageList.price|toFixed(2)}} </s>
                    </p>
                    <p class="p02"
                        price="6180.00"
                        id="pPrice" v-if="this.$route.query.productmoreid == 1">
                        <span class="zks"  >试用保证金:</span>
                        
                         ￥{{productmessageList.cprice|toFixed(2)}}

                    
                    </p>
                  </div>
                  <div class="zk"
                       v-if="this.$route.query.productmoreid == 3">
                    剩余 {{productmessageList.stock}}件
                    <em v-bind:style="{ width:productmessageList.bfb}"> </em>
                  </div>
                  <dl v-if="productlist.iscolor==0&&this.$route.query.productmoreid==undefined">
                    <dt><em>选择颜色</em></dt>
                    <dd><em>选择数量</em>
                      <p>
                        <span class="pro_numadd"
                              @click="minus()"></span>
                        <input class="pro_numlabel"
                               type="text"
                               value="1"
                               id="txtNum"
                               v-model='Pnumber'>
                        <span class="pro_numsubtract"
                              @click="add()"></span>
                      </p>
                    </dd>
                    <div class="clearfix"></div>
                  </dl>
                  <a @click="purchase (Pnumber,Allsum)"
                     id="linkBuy"
                     v-if="productmessageList.is_xp==0&&productmessageList.is_old!=1">立即购买</a>
                </div>

              </div>

            </div>
          </div>
          <!--内容结束-->
        </div>
        <div class="main parameter_main">
          <div class="product_xx_parameter">
            <ul>
              <li class="li01"
                  style="height: 159px;">规格参数</li>
              <span v-html="productmessageList.specif" >
                {{productmessageList.specif}}
              </span>
              <div class="clearfix"></div>
            </ul>
          </div>
        </div>

        <div class="main parameter">
          <p class="xinneng">产品描述</p>
          <div class="editor">

            <div v-html="productmessageList.protext">
              {{productmessageList.protext}}
            </div>

          </div>

          <div class="back"><a @click="product()">返回</a></div>
          <div class="parameter_bottom">
            <h5>

              <a @click='toParts()'>更多配件</a>
              相关配件</h5>

            <div class="parameter-container">
              <div class="parameter-wrapper">
                <div class="parameter-swiper">

                  <ul class="swiper-wrapper">

                    <li class="swiper-slide"
                        v-for="(item,index) in BJList"
                        :key="index"
                        @click="topj(item)"
                        v-show="index>1&&index<6">

                      <a>
                        <img :src="httpurl+item.image">
                        <span>
                          <h3>{{item.name}}</h3>
                          <p>{{item.detail}}</p>
                          <h5>
                            <img src="../assets/icon04.png"
                                 style="width: 29px;height: 29px;">
                          </h5>
                        </span>
                      </a>
                    </li>

                  </ul>

                </div>
                <div class="swiper-switch-prev parameter-swiper-prev"></div>
                <div class="swiper-switch-next parameter-swiper-next"></div>
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>
</template>
<script>
import qs from 'qs'
import { mapActions, mapGetters } from 'vuex'
import myHeader from '@/views/headerimg'
import { getpro, getproduct } from "@/api/api";
export default {
  components: { myHeader },
  data () {
    return {
        cpxxshow:false,
      moreid: '',
      Pnumber: 1,
      Allsum: '',
      childid: '',
      productmessageList: {},
      httpurl: 'http://shop.qdc.com/',
      BJList: '',
      delivery_asn: '',
      productlist:{
          iscolor:0
      },
      zk:'',
      price2:'',
    }
  },
  computed: {
    // productname () {
    //   return this.$store.state.Childproductlist.name
    //   console.log(this.productname)
    // },
    // productlist () {
    //   return this.$store.state.productlist
    //   console.log(this.productlist)
    // },
  },
  created () {
      if (localStorage.getItem('newukey') == '' || localStorage.getItem('newukey') == null) {
        this.ukey = 0
      }else{
          this.ukey=localStorage.getItem('newukey')
      }
       if (localStorage.getItem('discount') == '' || localStorage.getItem('discount') == null) {
        this.zk = 1
      }else{
          this.zk=localStorage.getItem('discount')
      }
    if (localStorage.getItem("prpductnewlist") != null) {
      var list = JSON.parse(localStorage.getItem('prpductnewlist'));
      this.productlist = list
    } else {
      this.productlist.iscolor = 0
    }
    if (localStorage.getItem("newChildproductlist") != null) {
      var list = JSON.parse(localStorage.getItem('newChildproductlist'));
      this.productname = list.name
    } else {
      this.productname = '无线耳机'
    }
    this.getproductmessageList();
    this.getproductlist();
  },
  watch: {
    "$route": "getproductmessageList"
  },
  methods: {
   
    topj (item) {
      this.$router.push({
        path: '/MixedCellSeriesMore',
        query: {
          childid: item.id,

        }

      });
      this.productname = '配件'
    },
    add: function () {
      if (this.Pnumber > 1||this.Pnumber == 1) {
        this.Pnumber++;
      }


      this.Allsum = parseInt(this.Pnumber) * parseInt(this.productmessageList.price);
    },
    minus: function () {
      if (this.Pnumber > 1) {
        this.Pnumber--;
      } 

      this.Allsum = parseInt(this.Pnumber) * parseInt(this.productmessageList.price);
    },
    toParts () {
      //   this.$router.push('/Mix')
      this.$router.push({
        path: '/MixedCellSeries',
        query: {
          productindex: 22,
        }

      });

    },
    getproductlist () {
      var para = {
        id: 22
      };
    //   console.log(para)

      getproduct(para).then(res => {
        if (res.data.error_code == 200) {
        //   console.log('BJList:' + res.data)
          this.BJList = res.data.productList.list

        } else {
          console.info(res.data.msg, err);
        }
      }).catch(err => { console.info("调用失败", err); })
    },

    getproductmessageList () {
        
      if (this.$route.query.childid) {
        this.moreid = this.$route.query.childid
      } else {
        this.moreid = 54
      }
      var self = this;

      var para = {
        id: this.moreid,

      };


      getpro(para).then(res => {
        // console.log("产品详情列表请求成功", res.data);
this.cpxxshow=true
        this.productmessageList = res.data.pro
        if (this.$route.query.productmoreid == 1) {
          this.Allsum = this.productmessageList.cprice
        }
        else if (this.$route.query.productmoreid == 2) {
          this.Allsum = this.productmessageList.aprice
        } else if(this.$route.query.productmoreid == 3) {
          this.Allsum = this.productmessageList.bprice
        }else{
            this.Allsum=this.productmessageList.price
        }

        res => {
          console.info("调用失败", res);
        };
      });

    },
    product () {
      if (this.$route.query.productmoreid == 1) {
        window.location.href = 'http://shop.qdc.com/activity/newlist.html'
      }else if(this.$route.query.productmoreid == 2){
           window.location.href = 'http://shop.qdc.com/activity/discount.html'
      }else if(this.$route.query.productmoreid == 3){
           window.location.href = 'http://shop.qdc.com/activity/promotion.html'
      }else if(this.$route.query.productmoreid == 4){
           window.location.href = 'http://shop.qdc.com/home/index.html'
      }
      else {
        window.history.go(-1)
      }
      //   this.$router.push('/')

    },
    purchase (Pnumber, Allsum) {
        //  console.log(' console.log(this.ukey)::::'+this.ukey)
       
      //   this.$router.push('/PurchaseFusion')
      if(this.$route.query.more=='a'){
       
        this.price2=this.Allsum*this.zk
        console.log("price"+this.price2)
        localStorage.setItem('zhprice', this.price2)
      }
     

      if (this.productlist.iscolor == 1) {
        this.$router.push({
          path: '/PurchaseFusion',
          query: {
            childid: this.$route.query.childid,

          }

        });
        //  this.$router.push({ path: "/PurchaseFusion" });
      } 
      else {
         
           if (this.ukey == 0) {
              alert('请先登录') 
             window.location.href = 'http://shop.qdc.com/member/login.html?ml=1&childid='+this.$route.query.childid
            }else if(this.$route.query.productmoreid){
               this.$router.push({
          path: '/OderCenter',
          query: {
            productmoreid:this.$route.query.productmoreid,
            childid: this.$route.query.childid,
            iscolor: 0,
          }

        });  
            }
            
            else{
this.$router.push({
          path: '/OderCenter',
          query: {
            childid: this.$route.query.childid,
            iscolor: 1,
          }

        });
         localStorage.setItem('zhprice2', this.price2)
            }

        //  this.$store.dispatch("ChangeYwwLagre", item);
        
        this.$store.dispatch("ChangePnumber", Pnumber);
        this.$store.dispatch("ChangeAllsum", Allsum);

      }
      // console.log('color:'+item.iscolor)
      //   console.log('this.productList.id,' + item.id)


    }

  }
};
</script>

<style scoped>
@import "../../static/newlayout.css";
.zks {
  color: #999;
  font-size: 14px;
}
.zk {
  border-radius: 30px;
  white-space: nowrap;
  text-align: center;
  border: 1px solid #c9c9c9;
  display: block;
  width: 90px;
  padding: 0 10px;
  font-size: 12px;
  overflow: hidden;
  position: relative;
  margin-bottom: 10px;
  color: #fff;
  border-color: #2da0f7;
  background-color: transparent;
  line-height: 28px;
  z-index: 2;
}
.zk em {
  width: 85%;
  height: 100%;
  background-color: #2da0f7;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: -1;
}
.editor {width: 100%;margin: 0 auto;min-height: 300px;font-size: 14px;font-family: "å®‹ä½“";line-height: 24px;color: #666;transition: all 0.2s;-webkit-transition: all 0.2s;}
.editor /deep/ p {line-height: 24px;}
.editor /deep/ img {max-width: 100% !important;}
.editor /deep/ table {width: 100% !important;}
@media(mx-width:1080px){
	img {max-width: 100% !important;}
	table {max-width: 100% !important;}
}
</style>




// WEBPACK FOOTER //
// src/views/MixedCellSeriesMore.vue